/**
 * Безопасно конвертирует любое значение в Date объект.
 * Поддерживает: Date, ISO строки, timestamp (число), и null/undefined.
 */
export function toSafeDate (value: unknown): Date | null {
  if (!value) return null
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value
  }
  if (typeof value === 'number' || typeof value === 'string') {
    const date = new Date(value)
    return isNaN(date.getTime()) ? null : date
  }
  return null
}
